import request from '@/utils/request'

// 查询当前用户可见的快捷导航列表
export function listQuickNav() {
  return request({
    url: '/wms/quickNav/list',
    method: 'get'
  })
}

// 查询快捷导航配置用菜单树（所有登录用户，树按当前账号权限过滤）
export function getQuickNavMenuTree() {
  return request({
    url: '/wms/quickNav/menuTree',
    method: 'get'
  })
}

// 保存当前用户的快捷导航配置（整体替换，只影响自己）
export function saveQuickNav(data) {
  return request({
    url: '/wms/quickNav/save',
    method: 'post',
    data: data
  })
}
